module.exports = __webpack_public_path__ + "img/specials-multislider-6040--honda.41157c8c.jpeg";